import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    LabelList,
    ResponsiveContainer,
    CartesianGrid,
    Legend
} from "recharts";
import { formatVisibleNumber } from "../../components/selfcare360/selfcare360Scales";

const APP_PURPLE = '#3E246B';
const APP_GREEN = '#339C98';
const GAP_LABEL_AXIS_WIDTH = 210;
const GAP_VALUE_RIGHT_MARGIN = 84;

const GapChartSelfcare360 = ({ dimensions }) => {
    if (!dimensions || dimensions.length === 0) return null;

    const parsedDimensions = dimensions.map((dimension) => ({
        ...dimension,
        auto: dimension.auto != null && Number.isFinite(Number(dimension.auto)) ? Number(dimension.auto) : null,
        others: Number.isFinite(Number(dimension.others)) ? Number(dimension.others) : 0,
    }));

    const renderValueLabel = (fill) => (props) => {
        const { x, y, width, height, value } = props;
        if (value == null) return null;
        const numericValue = Number(value);

        if (!Number.isFinite(numericValue)) return null;

        return (
            <text
                x={(x || 0) + (width || 0) + 6}
                y={(y || 0) + (height || 0) / 2}
                fill={fill}
                fontSize={10}
                fontWeight={'bold'}
                dominantBaseline="middle"
                textAnchor="start"
            >
                {formatVisibleNumber(numericValue)}
            </text>
        );
    };

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const autoValue = payload.find((item) => item.dataKey === 'auto')?.value;
            const othersValue = payload.find((item) => item.dataKey === 'others')?.value;

            return (
                <div style={{ backgroundColor: 'white', padding: 10, border: '1px solid #ccc', display: 'flex', flexDirection: 'column', gap: 4, maxWidth: 320 }}>
                    <span><strong>{label}</strong></span>
                    <span style={{ color: APP_PURPLE, fontWeight: 600 }}>Autoevaluación: {formatVisibleNumber(autoValue)}</span>
                    <span style={{ color: APP_GREEN, fontWeight: 600 }}>Promedio otros: {formatVisibleNumber(othersValue)}</span>
                </div>
            );
        }

        return null;
    };

    return (
        <ResponsiveContainer width="100%" height={Math.max(parsedDimensions.length * 42, 360)}>
            <BarChart
                data={parsedDimensions}
                layout="vertical"
                barGap={6}
                barCategoryGap="24%"
                margin={{ top: 10, right: GAP_VALUE_RIGHT_MARGIN, left: 20, bottom: 10 }}
            >
                <CartesianGrid horizontal={false} stroke="#dbe4ef" />
                <XAxis
                    type="number"
                    domain={[0, 100]}
                    ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    orientation="top"
                    tickFormatter={(tick) => `${tick}%`}
                    tick={{ fontSize: 9, fill: '#94a3b8' }}
                    tickLine={false}
                    axisLine={false}
                    height={22}
                />
                <YAxis
                    type="category"
                    dataKey="title"
                    width={GAP_LABEL_AXIS_WIDTH}
                    tick={{ fontSize: 11, fill: '#475569' }}
                    tickLine={false}
                    axisLine={false}
                />
                <Tooltip content={<CustomTooltip />} wrapperStyle={{ zIndex: 1000 }} />
                <Legend verticalAlign="bottom" height={36} />

                <Bar dataKey="auto" name="Autoevaluación" fill={APP_PURPLE} barSize={12} radius={[0, 8, 8, 0]} isAnimationActive={false}>
                    <LabelList dataKey="auto" content={renderValueLabel(APP_PURPLE)} />
                </Bar>
                <Bar dataKey="others" name="Promedio Otros (Brecha)" fill={APP_GREEN} barSize={12} radius={[0, 8, 8, 0]} isAnimationActive={false}>
                    <LabelList dataKey="others" content={renderValueLabel(APP_GREEN)} />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default GapChartSelfcare360;
